module["exports"] = ["Dr.", "Ir.", "Ing.", "Prof."];